import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FormulariosCudAbm } from './pages/FormulariosCudAbm';
import { setDiscapacidadRoute } from '../../../actions/discapacidad/discapacidadActions';
import { TipoDocumentacionIntegracionAbm } from './pages/TipoDocumentacionIntegracionAbm';
import { TipoDocumentacionSolicitudIntegracionAbm } from './pages/TipoDocumentacionSolicitudIntegracionAbm';
import { TipoDocumentacionAfiliadosIntegracionAbm } from './pages/TipoDocumentacionAfiliadosIntegracionAbm';

const routes = {
    formulariosAbm: "formularios",
    tipoDocumentacionIntegracionAbm: "documentacionIntegracion",
    tipoDocumentacionIntegracionSolicitudAbm: "documentacionIntegracionSolicitud",
    tipoDocumentacionIntegracionGeneralidadesAbm: "documentacionIntegracionAfiliados",
}

export const ConfiguracionesCud = ({ match }) => {
    const dispatch = useDispatch();
    const { section } = match.params;
    const { route } = useSelector((state) => state.discapacidad);

    useEffect(() => {
        dispatch(setDiscapacidadRoute(section))
    }, [route]);

    return (
        <>
            {
                ((route === routes.formulariosAbm) && <FormulariosCudAbm />) ||
                ((route === routes.tipoDocumentacionIntegracionAbm) && <TipoDocumentacionIntegracionAbm />) ||
                ((route === routes.tipoDocumentacionIntegracionSolicitudAbm) && <TipoDocumentacionSolicitudIntegracionAbm />) ||
                ((route === routes.tipoDocumentacionIntegracionGeneralidadesAbm) && <TipoDocumentacionAfiliadosIntegracionAbm />)
            }
        </>
    );
}
